import { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import NexlayerIcon from './NexlayerIcon'

const LINKS = [
  { href: '/#data-security', label: 'Data & security' },
  { href: '/#savings', label: 'Savings' },
  { href: '/#benchmark', label: 'Benchmark' },
  { to: '/models', label: 'Models' },
]

export default function Header() {
  const [open, setOpen] = useState(false)
  const { pathname } = useLocation()
  const isHomeRoute = pathname === '/'
  const [pastHero, setPastHero] = useState(false)

  useEffect(() => {
    if (!isHomeRoute) return
    const onScroll = () => setPastHero(window.scrollY > window.innerHeight - 120)
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [isHomeRoute])

  const onHero = isHomeRoute && !pastHero

  const linkColor = onHero ? 'text-[rgba(245,245,243,.72)] hover:text-[#F5F5F3]' : 'text-[var(--muted)] hover:text-[var(--ink)]'
  const brandColor = onHero ? 'text-[#F5F5F3]' : 'text-[var(--ink)]'
  const barColor = onHero ? 'bg-[#F5F5F3]' : 'bg-[var(--ink)]'

  return (
    <header className={`sticky top-0 z-[100] ${onHero ? 'bg-transparent' : 'border-b border-[var(--line)] bg-[var(--paper)]'}`}>
      <div className="relative mx-auto max-w-[1080px] px-7">
        <nav className="flex items-center justify-between py-7">
          <Link to="/" className={`flex items-center gap-2.5 text-[1.05rem] font-semibold tracking-[-0.02em] no-underline ${brandColor}`}>
            <NexlayerIcon className={`h-[22px] w-[22px] flex-none ${onHero ? 'text-[#21B7CB]' : 'text-[var(--ink)]'}`} />
            LiquidBrain<span className="text-[#93A9FF]">.ai</span>
          </Link>

          <div className="hidden items-center gap-7 font-mono text-[13px] md:flex">
            {LINKS.map((l) =>
              l.to ? (
                <Link key={l.to} to={l.to} className={`no-underline transition-colors duration-150 ${linkColor}`}>{l.label}</Link>
              ) : (
                <a key={l.href} href={l.href} className={`no-underline transition-colors duration-150 ${linkColor}`}>{l.label}</a>
              )
            )}
            <a href="#reserve" data-reserve className="rounded-lg bg-[var(--ink)] px-[17px] py-[9px] font-medium text-[var(--paper)]! transition-colors duration-150 hover:bg-[var(--ink-blue)]">
              Bring us your workload
            </a>
          </div>

          <button
            type="button"
            aria-label={open ? 'Close menu' : 'Open menu'}
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
            className="flex h-9 w-9 flex-col items-center justify-center gap-[5px] md:hidden"
          >
            <span className={`h-[1.5px] w-5 transition-transform duration-200 ${barColor} ${open ? 'translate-y-[6.5px] rotate-45' : ''}`} />
            <span className={`h-[1.5px] w-5 transition-opacity duration-200 ${barColor} ${open ? 'opacity-0' : ''}`} />
            <span className={`h-[1.5px] w-5 transition-transform duration-200 ${barColor} ${open ? '-translate-y-[6.5px] -rotate-45' : ''}`} />
          </button>
        </nav>

        {open && (
          <div className="absolute inset-x-0 top-full flex flex-col gap-1 rounded-b-2xl border-t border-[rgba(245,245,243,.12)] bg-[#0A0A0A] px-3 py-4 font-mono text-[14px] shadow-[0_20px_50px_rgba(0,0,0,.4)] md:hidden">
            {LINKS.map((l) =>
              l.to ? (
                <Link
                  key={l.to}
                  to={l.to}
                  onClick={() => setOpen(false)}
                  className="rounded-md px-2 py-3 text-[rgba(245,245,243,.72)] no-underline transition-colors duration-150 hover:text-[#F5F5F3]"
                >
                  {l.label}
                </Link>
              ) : (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="rounded-md px-2 py-3 text-[rgba(245,245,243,.72)] no-underline transition-colors duration-150 hover:text-[#F5F5F3]"
                >
                  {l.label}
                </a>
              )
            )}
            <a
              href="#reserve"
              data-reserve
              onClick={() => setOpen(false)}
              className="mt-2 rounded-lg bg-[#F5F5F3] px-[17px] py-3 text-center font-medium text-[#0A0A0A]! transition-colors duration-150 hover:bg-[#93A9FF]"
            >
              Bring us your workload
            </a>
          </div>
        )}
      </div>
    </header>
  )
}
